
// ComprasPage.js

import React, { useState, useEffect } from 'react';
import Header from '../../components/Header.js';
import { useTheme } from '../../contexts/ThemeContext.js';
import ExibirCompra from '../../components/ExibirCompra.js';
import CadastrarCompra from '../../components/CadastrarCompra.js';
import EditarCompra from '../../components/EditarCompra.js';
import ListarCompras from '../../components/ListarCompras.js';
import BotoesdeNavegacao from '../../components/BotoesdeNavegacao.js';
import BotoesDeAcao from '../../components/BotoesDeAcao.js';
import { useNavigate } from 'react-router-dom';
//import Axios from 'axios';
import api from '../../config/axiosConfig'; 
import '../../App.css';

function ComprasPage() {
  const { theme } = useTheme();
  const [compras, setCompras] = useState([]);
  const [selectedCompra, setSelectedCompra] = useState("");
  const [showCadastroCompra, setShowCadastroCompra] = useState(false);
  const [showEditaCompra, setShowEditaCompra] = useState(false);
  const [showExibeCompra, setShowExibeCompra] = useState(false);
  const [showListaCompras, setShowListaCompras] = useState(false); // Estado para controlar a exibição do componente Listarcompras
  // eslint-disable-next-line no-unused-vars
  const [currentPage, setCurrentPage] = useState(1);
  // eslint-disable-next-line no-unused-vars
  const [totalPages, setTotalPages] = useState(1); // Inicialmente 1 página
  const [isSearchVisible, setIsSearchVisible] = useState(false);
  const [searchQuery, setSearchQuery] = useState({ codcompra: '', nomefor: '', cnpjfor: '' });
  const navigate = useNavigate(); // Definindo o useNavigate
  
// Função para carregar as compras
const loadCompras = async (pageNumber = 1) => {
  console.log('Carregando compras...');
  try {
    // Primeiro, carregue a quantidade total de compras
    const countResponse = await api.get(`/compras/listarcompras`);

    const totalCompras = countResponse.data.totalElements;
    const pageSize = 10; // Tamanho fixo da página
    const totalPages = Math.ceil(totalCompras / pageSize);
    
    // Solicite a última página de compras
    const lastPage = totalPages > 0 ? totalPages - 1 : 0;
    const response = await api.get(`/compras/listarcompras/paginados?page=${lastPage}&size=${pageSize}`);

    setCompras(response.data.content);
    
    // Se houver compras, selecione a última compra
    if (response.data.content.length > 0) {
      const lastCompra = response.data.content[response.data.content.length - 1];
      setSelectedCompra(lastCompra);
      setShowExibeCompra(true);
    }
    
    setTotalPages(totalPages);
  } catch (error) {
    console.error('Erro ao carregar compras:', error);
  }
  };
  
  
// Função para exibir a compra selecionado
const handleCodcompraClick = async (compraCodcompra) => {
  try {
    // Fechar o componente ListarCompras
    handleSairListarClick();

    // Buscar a compra pelo código
    const response = await api.get(`/compras/buscarcompra?codcompra=${compraCodcompra}`);

    if (response.data) {
      const compra = response.data; // A API está retornando um objeto único de compra
      setSelectedCompra(compra); // Define a compra selecionada
      setShowExibeCompra(true); // Exibe o componente de exibição de compra
    } else {
      window.alert('Compra não encontrada.');
    }
  } catch (error) {
    console.error('Erro ao buscar compra:', error);
    window.alert('Erro ao buscar compra. Verifique o console para mais detalhes.');
  }
};
  
// Funções de navegação
// Função para buscar a primeira compra
const fetchPrimeiraCompra = async () => {
  try {
    const response = await api.get('/compras/primeira');

    if (response.data && response.data.codcompra) {
      console.log('Primeira compra encontrada-02:', response.data);
      setSelectedCompra(response.data);
      setShowExibeCompra(true);
      } else {
        console.log('Nenhuma Compra Cadastrada.');
        setSelectedCompra(response.data);
        setShowExibeCompra(true);
        window.alert('Nenhuma Compra Cadastrada.');
      }
    } catch (error) {
      console.error('Erro ao buscar a Primeira Compra:', error);
      setSelectedCompra("");
      setShowExibeCompra(true);
      window.alert('Nenhuma Compra Cadastrada.');
    }
  };
  
// Função para buscar a Compra Anterior
const fetchCompraAnterior = async () => {
  if (selectedCompra && selectedCompra.id) {
    console.log('Buscando compra anterior para o ID:', selectedCompra.id);
    try {
      const response = await api.get(`/compras/anterior/${selectedCompra.id}`);

      if (response.data) {
        //console.log('compra anterior encontrada:', response.data);
        setSelectedCompra(response.data);
        setShowExibeCompra(true);
      } else {
        console.warn('Nenhuma compra anterior encontrada.');
      }
    } catch (error) {
      console.error('Erro ao buscar o compra anterior:', error);
    }
  } else {
    console.error('Nenhum compra selecionado ou compra sem ID');
  }
};
  
// Função para buscar a compra posterior
const fetchCompraPosterior = async () => {
  if (selectedCompra && selectedCompra.id) {
      console.log('Buscando compra posterior para o ID:', selectedCompra.id); // Log do ID do compra selecionado
    try {
      const response = await api.get(`/compras/proxima/${selectedCompra.id}`);

      if (response.data) {
        //console.log('compra posterior encontrada:', response.data); // Log do compra posterior encontrado
        setSelectedCompra(response.data);
        setShowExibeCompra(true);
        } else {
          console.warn('Nenhum compra posterior encontrada.');
        }
      } catch (error) {
        console.error('Erro ao buscar a compra posterior:', error);
      }
    } else {
      console.error('Nenhuma compra selecionado ou compra sem ID');
    }
  };

// Função para buscar a última compra
const fetchUltimaCompra = async () => {
  try {
    const response = await api.get('/compras/ultima');

    if (response.data) {
      //console.log('Última compra encontrada:', response.data);
      setSelectedCompra(response.data);
      setShowExibeCompra(true);
    }
  } catch (error) {
    console.error('Erro ao buscar a última compra:', error);
  }
};

  
  // Efeito para carregar a última compra quando o componente for montado
    useEffect(() => {
    fetchUltimaCompra();
  }, [currentPage]);


  // Função para Buscar Compra por Código da Compra
  const fetchCompraPorCodcompra = async (codcompra) => {
    console.log('Buscando compra por Código da Compra:', codcompra);
    try {
      const response = await api.get(`/compras/buscarcompra?codcompra=${codcompra}`);

    if (response.data) {
        console.log('Compra encontrada por Código:', codcompra);
        setSelectedCompra(response.data);  // Acessa diretamente o objeto retornado
        setShowExibeCompra(true);
      } else {
        console.warn('Compra não encontrada por Código: ', codcompra);
        window.alert('Compra não encontrada por Código: ', codcompra);
        fetchUltimaCompra();
      }
    } catch (error) {
      console.error('Erro ao buscar compra por Código da Compra:', error);
      window.alert('Compra Não Encontrada por Código da Compra: ', codcompra);
      fetchUltimaCompra();
    }
  };


  // Função para Buscar Compra por Nome do Cliente
  const fetchCompraPorNomefor = async (nomefor) => {
    console.log('Buscando compra mais recente por Nome do Cliente:', nomefor);
    try {
        const response = await api.get(`/compras/buscarcompra?nomefor=${nomefor}`);

        if (response.data) {
            console.log('Compra encontrada por Nome do Cliente:', nomefor);
            setSelectedCompra(response.data);
            setShowExibeCompra(true);
        } else {
            console.warn('Compra não encontrada por Nome do Cliente:', nomefor);
            window.alert('Compra não encontrada por Nome do Cliente:', nomefor);
            fetchUltimaCompra();
        }
    } catch (error) {
        console.error('Erro ao buscar compra por Nome do Cliente:', error);
        window.alert('Erro ao buscar compra por Nome do Cliente');
        fetchUltimaCompra();
    }
};

  // Função para buscar compra mais recente por CNPJ do Cliente
  const fetchCompraPorCnpjfor = async (cnpjfor) => {
    console.log('Buscando compra por CNPJ do Cliente:', cnpjfor);
    try {
        const response = await api.get(`/compras/buscarcompra?cnpjfor=${cnpjfor}`);

        if (response.data) {
            console.log('Compra encontrada por CNPJ do Cliente:', cnpjfor);
            setSelectedCompra(response.data);
            setShowExibeCompra(true);
        } else {
            console.warn('Compra não encontrada por CNPJ do Cliente:', cnpjfor);
            window.alert('Compra não encontrada por CNPJ do Cliente:', cnpjfor);
            fetchUltimaCompra();
        }
    } catch (error) {
        console.error('Erro ao buscar compra por CNPJ do Cliente:', error);
        window.alert('Erro ao buscar compra por CNPJ do Cliente');
        fetchUltimaCompra();
    }
};

  // Função para listar compras cadastradas
  const handleListarClick = () => {
    setShowListaCompras(true); // Ao clicar no botão Listar, mostrar o componente Listarcompras
    setShowExibeCompra(false); // Esconder o componente ExibirCompra
  };

  // Função para sair do Listarcompras
  const handleSairListarClick = () => {
    setShowListaCompras(false); // Ao clicar no botão Sair do Listarcompras, esconder o componente Listarcompras
    setShowExibeCompra(true); // Mostrar novamente o componente ExibExibirCompraircompra
  };

  // Função para cadastrar Nova compra
  const handleNovoClick = () => {
    setSelectedCompra("");
    setShowCadastroCompra(true);
    setShowEditaCompra(false);
    setShowExibeCompra(false);
  };

  // Função para Salvar Cadastro Nova compra
  const handleSalvarNovaCompra = (compra) => {
    setCompras([...compras, compra]);
    setSelectedCompra(compra);
    setShowCadastroCompra(false);
    setShowExibeCompra(false);
    setShowEditaCompra(true);
    ///window.alert('Compra Salva com Sucesso');
  };


  // Função para cancelar o cadastro da compra
  const handleCancelarNovaCompra = () => {
    setShowCadastroCompra(false);
    fetchUltimaCompra(); // Carrega a última compra da lista
    setShowExibeCompra(true);
  };



  // Função para editar Compra Selecionado
  const handleEditClick = () => {
    setShowEditaCompra(true);
    setShowCadastroCompra(false);
    setShowExibeCompra(false);
  };

  // Função para Salvar Compra Editada
  const handleSalvaEditada = (compra) => {
    setCompras([...compras, compra]);
    setSelectedCompra(compra);
    setShowExibeCompra(true);
    setShowEditaCompra(false);
    //window.alert('Compra Editada com Sucesso');
  };

  // Função para cancelar a edição de compra
  const handleCancelaEditada = () => {
    setShowCadastroCompra(false);
    setShowEditaCompra(false);
    setShowExibeCompra(true);
  };

  // Função para fechar a página de exibição e ir para a página inicial
  const handleCancelaExibe = () => {
    setShowCadastroCompra(false);
    setShowEditaCompra(false);
    setShowExibeCompra(false);
    setCompras(""); // Reseta o estado da compra
    navigate('/home'); // Redireciona para a página inicial
  };


const handleDeleteClick = async () => {
  if (selectedCompra) {
    const confirmation = window.confirm(`Tem certeza que deseja excluir a compra ${selectedCompra.codcompra}?`);
    if (confirmation) {
      try {
        // Verifica se a compra tem itens associados
        const itensResponse = await api.get(`/compras/${selectedCompra.codcompra}/itens`);

        const itensCompra = itensResponse.data;

        if (itensCompra.length > 0) {
          // Se houver itens, mostra um alerta informando que os itens precisam ser excluídos primeiro
          window.alert('Para Excluir a Compra, antes é necessário Excluir os Itens desta Compra.');
        } else {
          // Se não houver itens, procede com a exclusão da compra
          await api.delete(`/compras/excluircompra/${selectedCompra.codcompra}`);

          window.alert(`Compra: ${selectedCompra.codcompra} Excluída com Sucesso.`);

          // Carregar compras novamente
          loadCompras(currentPage);
          // Buscar e exibir a última compra
          fetchUltimaCompra();
        }
      } catch (error) {
        console.error('Erro ao excluir a compra:', error);
      }
    }
  } else {
    console.error('Nenhuma compra selecionada para excluir');
  }
};

// Se os campos de busca estiverem sendo exibidos, limpa os campos de busca
  const handleSearchClick = () => {
    if (!isSearchVisible) {
    setSearchQuery({ codcompra: '', nomefor: '', cnpjfor: '' });
  }
    setIsSearchVisible(!isSearchVisible);
  };
  

// A função handleSearchChange faz a busca apenas quando a tecla Enter é pressionada
  const handleSearchChange = (e) => {
    const { name, value } = e.target;
    setSearchQuery({ ...searchQuery, [name]: value });
  };


  // Se a tecla pressionada for Enter, executar a busca
  const handleSearchByCodigo = (e) => {
    if (e.key === 'Enter') {
      fetchCompraPorCodcompra(searchQuery.codigo);
    }
  };

  const handleSearchByNome = (e) => {
    if (e.key === 'Enter') {
      fetchCompraPorNomefor(searchQuery.nome);
    }
  };

  const handleSearchByCNPJ = (e) => {
    if (e.key === 'Enter') {
      fetchCompraPorCnpjfor(searchQuery.cnpj);
    }
  };


  return (
    <div
      style={{
        backgroundColor: theme.background,
        color: theme.color,
        minHeight: 'calc(100vh - 20px)',
        width: '100%',
        paddingTop: '10px',
        textAlign: 'center',
      }}
    >
      <Header selectedEmpresa={localStorage.getItem('selectedEmpresa')} />


      {!showCadastroCompra && selectedCompra && !showEditaCompra && showExibeCompra && (
      <>
      <BotoesdeNavegacao
      fetchPrimeiro={fetchPrimeiraCompra}
      fetchAnterior={fetchCompraAnterior}
      fetchProximo={fetchCompraPosterior}
      fetchUltimo={fetchUltimaCompra}
      />
      <BotoesDeAcao
      handleNovoClick={handleNovoClick}
      handleEditClick={handleEditClick}
      handleDeleteClick={handleDeleteClick}
      handleSearchClick={handleSearchClick}
      handleListarClick={handleListarClick} // Verifique se handleListarClick está passada corretamente
      isSearchVisible={isSearchVisible}
      handleSearchChange={handleSearchChange}
      handleSearchByCodigo={handleSearchByCodigo}
      handleSearchByNome={handleSearchByNome}
      handleSearchByCNPJ={handleSearchByCNPJ}
      searchQuery={searchQuery}
      />
      <ExibirCompra compra={selectedCompra || {}}
        handleCancelaExibe={handleCancelaExibe}
      />
      </>
      )}

      
      {showListaCompras && (
        <ListarCompras
          onCodcompraClick={handleCodcompraClick} // Passa a função para quando o código da compra é clicado
          handleSairListarClick={handleSairListarClick} // Passa a função para fechar a listagem
        />
      )}


      {showCadastroCompra && (
        <CadastrarCompra
          handleSaveClick={handleSalvarNovaCompra}
          //handleCloseClick={handleFecharNovaCompra}
          handleCancelaClick={handleCancelarNovaCompra}
          compra={selectedCompra}
        />
      )}

      
      {showEditaCompra && (
      <EditarCompra
      compra={selectedCompra}
      handleEditClick={handleSalvaEditada}
      handleCancelaEdit={handleCancelaEditada}
      />
      )}
      
  </div>
  );
}

export default ComprasPage;
